export function isCanvasUIElement(element: Element) {
  return (
    element.nodeName === 'Y42-CANVAS-CONTEXT-MENU' ||
    element.nodeName === 'Y42-CANVAS-CHAT' ||
    element.nodeName === 'Y42-CANVAS-TOOLBOX'
  );
}

/**
 * Checks whether the given element is an interactive element of the widget.
 * Event, which target is within an interactive element, should be ignored by the canvas.
 */
export function isWidgetInteractiveElement(element: Element) {
  return !!element.closest('.ag-header');
}
